import type { Template } from "@/types";

export const PO_03_H1_V2: Template[] = [
    {
        id: "po-03-h1v2-01",
        name: "PO 01 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 56, y: 236, width: 566, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 630, y: 236, width: 280, height: 422, rotation: 0, imageRotation: 0 },
            { id: "3", x: 917, y: 236, width: 280, height: 422, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-02",
        name: "PO 02 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_02.png",
        size: [1252, 894],
        style: {},
        slots: [           
            { id: "1", x: 55, y: 231, width: 274, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 336, y: 231, width: 555, height: 413, rotation: 0, imageRotation: 0 },
            { id: "3", x: 898, y: 231, width: 274, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-03",
        name: "PO 03 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 74, y: 270, width: 236, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 270, width: 235, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 693, y: 270, width: 492, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-04",
        name: "PO 04 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 70, y: 81, width: 216, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 451, width: 216, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 293, y: 81, width: 888, height: 733, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-05",
        name: "PO 05 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 126, y: 153, width: 194, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 126, y: 451, width: 194, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 327, y: 153, width: 798, height: 588, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-06",
        name: "PO 06 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 205, y: 81, width: 216, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 205, y: 451, width: 216, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 665, y: 252, width: 548, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-07",
        name: "PO 07 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 71, y: 81, width: 888, height: 732, rotation: 0, imageRotation: 0 },
            { id: "2", x: 966, y: 81, width: 216, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 966, y: 451, width: 216, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-08",
        name: "PO 08 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 127, y: 153, width: 798, height: 588, rotation: 0, imageRotation: 0 },
            { id: "2", x: 932, y: 153, width: 194, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 932, y: 451, width: 194, height: 290, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-09",
        name: "PO 09 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 67, y: 270, width: 492, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 700, y: 270, width: 236, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 943, y: 270, width: 235, height: 353, rotation: 0, imageRotation: 0 }
        ],
    }
];